<nav class="megaMenu" id="megaMenuEquipments" aria-label="Equipos">
  <div class="secretDiv"></div>
  <div class="grid" (mouseleave)="checkHover()">
    <!-- PAGES -->
    <div class="pages">
      <a
        class="btn"
        routerLink="/equipos"
        (mouseenter)="onMouseEnter(0)"
        (click)="closeMainMenu()"
        [class.active]="activeIndex() === 0"
      >
        Equipo nuevo
        <div class="contentImage">
          <img ngSrc="/generals/arrowButton.svg" alt="icono flecha" fill />
        </div>
      </a>

      <a
        class="btn"
        routerLink="/usado"
        (mouseenter)="onMouseEnter(1)"
        (click)="closeMainMenu()"
        [class.active]="activeIndex() === 1"
      >
        Equipo usado
        <div class="contentImage">
          <img ngSrc="/generals/arrowButton.svg" alt="icono flecha" fill />
        </div>
      </a>

      <a
        class="btn"
        routerLink="/renta"
        (mouseenter)="onMouseEnter(2)"
        (click)="closeMainMenu()"
        [class.active]="activeIndex() === 2"
      >
        Renta de equipos
        <div class="contentImage">
          <img ngSrc="/generals/arrowButton.svg" alt="icono flecha" fill />
        </div>
      </a>
    </div>

    <!-- CATEGORIES -->
    <div class="categories">
      <!-- NUEVO -->
      <div class="contentNewCategories" [class.active]="activeIndex() === 0">
        @for (news of newCategories(); track news.slug) {
          <a [routerLink]="['/equipos', news.slug]" (click)="closeMainMenu()">
            {{ news.name }}
          </a>
        }

        <a routerLink="/equipos" class="goTo" (click)="closeMainMenu()"> Ver todo </a>
      </div>

      <!-- USADO -->
      <div class="contentNewCategories" [class.active]="activeIndex() === 1">
        @for (used of usedCategories(); track used.slug) {
          <a [routerLink]="['/usado/categorias', used.slug]" (click)="closeMainMenu()">
            {{ used.name }}
          </a>
        }

        <a routerLink="/usado/categorias" class="goTo" (click)="closeMainMenu()"> Ver todo </a>
      </div>

      <!-- RENTA -->
      <div class="contentNewCategories" [class.active]="activeIndex() === 2">
        <a routerLink="/renta" (click)="closeMainMenu()">Renta pura</a>
        <a routerLink="/renta" (click)="closeMainMenu()">Renta con opción a compra</a>
      </div>
    </div>
  </div>
</nav>
